/* eslint-disable no-unused-vars */
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color, lightTheme } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';
import {
  BP,
  LP,
  calculateNFTWithdrawalTime,
  formatUSD,
  formatUSDNoDecimals,
  walletsNFTWithdraw
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { PackageTrading, UserPackage } from './Portfolio.types';

import { PurchaseVoucher } from './PurchaseVoucher/PurchaseVoucher';
import { TextWithTooltip } from '../../components/common/TextWithTooltip';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { useDisconnect } from 'wagmi';
import { WithdrawalItemDisabled } from './WithdrawalItemDisabled';
import { PortfolioItemDisabled } from './PortfolioItemDisabled';

export const PortfolioBigWhaleItem = ({
  item,
  setPackageItem,
  setSelectedNFTWallet,
  withdrawModal,
  setWithdrawModal,
  transferAssetStatus
}: {
  item: PackageTrading;
  setPackageItem: Dispatch<SetStateAction<UserPackage | null>>;
  setSelectedNFTWallet: any;
  withdrawModal: boolean;
  setWithdrawModal: Dispatch<SetStateAction<boolean>>;
  transferAssetStatus: boolean;
}) => {
  const { t } = useTranslation('my_hubs');

  const [selectedHub, setSelectedHub] = useState();
  const [modal, setModal] = useState(false);

  const { disconnect } = useDisconnect();

  const showWithdrawableBigWhaleHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();

      if (days > 0) {
        return <WithdrawalItemDisabled />;
      }
    }
  };

  const showDisabledBigWhaleHub = (item: any) => {
    if (item?.dateNftWithdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.dateNftWithdrawal));
      const days = fromNow.days();
      const hours = fromNow.hours();

      if (days === 0 && hours < 24) {
        return (
          <PortfolioItemDisabled
            title={t('disabled_hub_title')}
            subtitle='It may take up to 24 Hours for Hub NFT to Refresh.'
          />
        );
      }
    }
  };

  const showWithdrawNFTButton = (item: any) => {
    if (item?.isWithdrawable && !item?.dateConverted && item?.nftId !== null) {
      return <Flexed column alignEnd></Flexed>;
    } else {
      return (
        calculateNFTWithdrawalTime(item) && (
          <Flexed column alignEnd>
            <Button
              color='#ffffff'
              borderColor='#CC0000'
              background='#CC0000'
              wSM='100%'
              w='200px'
              onClick={() => {}}
              negative={false}>
              TRANSFERRED
            </Button>
          </Flexed>
        )
      );
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage
          image={item?.image}
          isDisabled={calculateNFTWithdrawalTime(item)}>
          <H4 color={color.colors.neutral0}>{item?.name}</H4>
        </HubImage>
        <div>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {formatUSDNoDecimals(item.price)} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  BIGWHALE POINTS
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {formatUSDNoDecimals(item.price)} <P3 mb='3'>{BP}</P3>
                </P1>
              </Td>
              <Td w='20%' wSM='50%'></Td>
              <Td w='20%' wSM='50%'>
                {showWithdrawNFTButton(item)}
              </Td>
            </Tr>
          </div>
          <Flexed column gap='30px'>
            <Responsive style={{ margin: '24px 0' }} between>
              <Flexed mbSM='20' rowSM>
                <P3 caps bold color={color.colors.secondary100} mr='60'>
                  BIGWHALE PACKAGE DETAILS
                </P3>
                <P3 flex color={color.colors.secondary100} mr='60'>
                  {t('order_id')}:{' '}
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.id}
                  </P3>
                </P3>
                <P3 flex color={color.colors.secondary100} mr='60'>
                  Package ID:
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.packageId}
                  </P3>
                </P3>
                <P3 flex color={color.colors.secondary100}>
                  NFT ID:
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.nftId}
                  </P3>
                </P3>
              </Flexed>
            </Responsive>

            {item?.isMemeBonusActivated && item?.dateFinupBonus != null && (
              <div>
                <P3 caps bold color={color.colors.secondary100} mb='15'>
                  VOUCHER PURCHASED ✅
                </P3>
                <Tr style={{ cursor: 'pointer' }}>
                  <Td w='20%' wSM='50%'>
                    <CaptionText
                      caps
                      bold
                      color={color.colors.neutral500}
                      mb='10'>
                      {t('date_of_purchase')}
                    </CaptionText>
                    <P1 bold>
                      {moment(item?.dateFinupBonus).format('DD MMM YYYY')}
                    </P1>
                  </Td>

                  <Td w='20%' wSM='50%'>
                    <CaptionText
                      caps
                      bold
                      color={color.colors.neutral500}
                      mb='10'>
                      MEME COINS GENERATED
                    </CaptionText>
                    <P1 bold flex alignEnd gap='5px'>
                      {formatUSDNoDecimals(item.price)}{' '}
                      <P3 bold mb='2'>
                        PER DAY
                      </P3>
                    </P1>
                  </Td>
                </Tr>
              </div>
            )}
            {calculateNFTWithdrawalTime(item)
              ? showWithdrawableBigWhaleHub(item)
              : showDisabledBigWhaleHub(item)}
          </Flexed>
        </div>
      </BoxBig>
      <PurchaseVoucher
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </>
  );
};
